export const GroupSyncTypes = Object.freeze({
  Slave: "Slave",
  Master: "Master",
  NoSync: "NoSync",
});

export const DynamicGroupTypes = Object.freeze({
  Static: "Static",
  Dynamic: "Dynamic",
  FullDynamic: "FullDynamic",
});

export const GroupSyncTypeNames = Object.freeze({
  Slave: "Replica",
  Master: "Primary",
  NoSync: "Not Synced",
});

export const GroupSyncDescriptions = Object.freeze({
  Slave:
    "This group is synchronized from E-Groups, including all settings and members. The group should be edited in E-groups.",
  Master:
    "This is a GMS group and will synchronize all its settings and members to E-Groups.",
  NoSync:
    "This is a GMS group that will not be synchronized with E-groups. This does not automatically remove an existing group from E-groups, which has to be done manually.",
});

export const GroupValidInternalStates = Object.freeze({
  Active: "Active",
  GracePeriod: "GracePeriod",
  Created: "Created",
});
